import { CircularProgress, TextField } from '@mui/material';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axoisInstance from '../../../utils/axiosInstance';
import { toast } from 'sonner';
import Cookies from 'js-cookie';

const Forgotpassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleForgot = async(e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await axoisInstance.post('/auth/forgotpassword', { email });
            toast.success("Success! Please check your email for the reset token.");
            Cookies.set('forgot_password_email', email);
            
            navigate('/auth/resetpassword')
            setEmail('');
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    toast.error("Failure! User not found.");
                } else if (error.response.status === 400) {
                    toast.error("Failure! Invalid email format.");
                } else {
                    toast.error("Failure! Something went wrong, please try again.");
                }
            } else {
                toast.error("Failure! Network error, please check your connection.");
            }

            console.log(error);
        } finally {
            setLoading(false);
        }

    }
    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6 text-center text-blue-800">Forgot Password</h2>
                <p className="text-gray-600 mb-4">Enter your email address to reset your password.</p>
                <form>
                    <div className="mb-4">
                        <TextField label="Email" type="email" fullWidth value={email} onChange={(e) => setEmail(e.target.value)} required variant="outlined" />
                    </div>
                    <button type="submit" disabled={loading} className={`w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition duration-200 ${loading && 'cursor-progress'}`} onClick={handleForgot}>
                        {loading ? <CircularProgress /> : 'Reset Password'}
                    </button>
                </form>
            </div>
            <div className="text-center mt-4">
                <p className="text-gray-400">Remembered your password? <Link to="/auth/login" className="text-blue-500 hover:text-blue-700">Login</Link></p>
            </div>
        </div>
    )
}

export default Forgotpassword
